const height = (state = window.innerHeight, action) => {
    switch(action.type) {
        case 'height':
            return action.payload;
        default:
            return state;
    }
}

export default height;